import { takeEvery, put, takeLatest } from "redux-saga/effects";
import { message } from "antd";

import ACTION from "../action";
import { ApiNames } from "../../api/api";
import { callApi } from "./networkActions";

function* searchAssistanceProgram({ searchQuery, filters }) {
  // All drug types (BN, PIN, BPCK, GPCK) are now handled uniformly in rxnormDrugsFilter
  // Packs extend by pinCui just like non-branded drugs
  const assistanceProgramRes = yield callApi(ApiNames.AssistanceProgramSearch, searchQuery, filters);
  if (assistanceProgramRes) {
    yield put(ACTION.setAssistancePrograms(assistanceProgramRes.programsInPage));
  }
}

function* selectAssistanceProgram({ id }) {
  yield put(ACTION.setShowAssistanceProgramModal(true));
  const assistanceProgramRes = yield callApi(ApiNames.AssistanceProgram, id);
  if (assistanceProgramRes) {
    yield put(ACTION.setSelectedAssistanceProgram(assistanceProgramRes));
  } else {
    message.error(`Failed to display the program id:${id}`);
    yield put(ACTION.setShowAssistanceProgramModal(false));
  }
}

function* sendSupportTicket({ subject, comment, user }) {
  const SupportRes = yield callApi(ApiNames.Support, subject, comment, user);
  if (SupportRes) {
    yield put(ACTION.setShowAssistanceProgramModal(false));
    message.success("Ticket send successfully");
  } else {
    message.error("Ticket send failed");
  }
}

function* updateNotificationPreferences({ preferenceType, targetId, notificationType, isEnabled }) {
  const updateRes = yield callApi(
    ApiNames.UpdateNotificationPreferences,
    preferenceType,
    targetId,
    notificationType,
    isEnabled
  );

  const notificationPreferencesRes = yield callApi(ApiNames.NotificationPreferences);
  if (notificationPreferencesRes) {
    yield put(ACTION.setNotificationPreferences(notificationPreferencesRes));
  }

  if (!updateRes) {
    message.error("Failed to update notification preferences");
  }
}

function* actions() {
  yield takeLatest(ACTION.Types.SEARCH_ASSISTANCE_PROGRAM_ACTION, searchAssistanceProgram);
  yield takeEvery(ACTION.Types.SELECT_ASSISTANCE_PROGRAM_ACTION, selectAssistanceProgram);
  yield takeEvery(ACTION.Types.SEND_SUPPORT_TICKET, sendSupportTicket);
  yield takeEvery(ACTION.Types.UPDATE_NOTIFICATION_PREFERENCES_ACTION, updateNotificationPreferences);
}

export { actions };
